<template>
  <pop-up-layout
    :title="!editar ? localization.titleCrear : localization.titleEditar + ' ' + item.name"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    aceptar="Aceptar"
    @volver="cerrarPopup()"
    @aceptar="enviarPromocion()"
  >
    <Alerts></Alerts>
    <v-form v-model="valid" id="valid" ref="formPromociones" autocomplete="off" >
    <v-col cols="12">
      <v-row class="pl-6">
        <v-col cols="3" md="3">

            <v-text-field
            :rules="[rules.obligatorio, rules.max(10)]"
            v-model="codigo" id="codigo"
            :label="localization.camposPromocion.codigo"
          />
        </v-col>
        <v-col cols="9" md="9">
            <v-text-field
            :rules="[rules.obligatorio, rules.max(100)]"
            v-model="nombre" id="nombre"
            :label="localization.camposPromocion.descripcion"
          />
        </v-col>
        <v-col cols="4" md="4">
           <v-autocomplete
              :label="localization.buscar"
              v-model="sociedadSelectedId" id="sociedadSelectedId"
              :items="allSocieties"
              item-value="id"
              item-text="name"
            />
        </v-col>
        <v-col cols="4" md="4">
             <v-text-field
            v-model="sector" id="sector"
            :label="localization.camposPromocion.sector"
            :rules="[rules.max(100)]"
          />
        </v-col>

        <v-col cols="12" >
          <v-row>
            <h2 class="primary--text text-uppercase" style="font-size: 18px">
              Ubicación
            </h2>
          </v-row>
          <v-row style="padding-left:0px">
            <v-col cols="12" style="padding-left:0px">
              <v-divider class="divider_subtitle" style="padding-left:0px"></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="9" md="9">

             <v-text-field
            v-model="direccion" id="direccion"
            :label="localization.camposPromocion.direccion"
            :rules="[rules.max(250)]"
          />
        </v-col>
        <v-col cols="3" md="3">
          <v-text-field
            :rules="[rules.max(10)]"
            v-model="codigoPostal" id="codigoPostal"
            :label="localization.camposPromocion.codigoPostal"
          />
        </v-col>


        <v-col cols="4" md="4">
          <v-text-field
            v-model="poblacion" id="poblacion"
            :rules="[rules.max(100)]"
            :label="localization.camposPromocion.poblacion"
          />
        </v-col>
        <v-col cols="4" md="4">
            <v-text-field
            v-model="provincia" id="provincia"
            :rules="[rules.max(100)]"
            :label="localization.camposPromocion.provincia"
          />
        </v-col>
        <v-col cols="4" md="4">
            <v-text-field
            v-model="pais" id="pais"
            :rules="[rules.max(100)]"
            :label="localization.camposPromocion.pais"
          />
        </v-col>
      </v-row>
      <o-file-uploader
        v-model="files" id="files"
        :titulo="'Añadir foto'"
        :icon="'photo'"
        :maxNum="1"
        :imagesOnly="true"
        @input="cambiarFoto()"
      />
    </v-col>
    </v-form>
  </pop-up-layout>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'

export default {
  components: {
    Alerts
  },
  mixins: [rulesMixin],
  props: {
    item: null,
    editar: null
  },
  data () {
    return {
      valid: false,
      waitingForLoad: false,
      loading: false,
      socSelected: null,
      codigo: null,
      nombre: null,
      sociedadSelectedId: null,
      codSociedad: null,
      descSociedad: null,
      codigoPostal: null,
      direccion: null,
      sector: null,
      files: [],
      pais: null,
      provincia: null,
      poblacion: null,
      allSocieties: null,
      fotoCambiada: false
    }
  },
  async created () {
    this.allSocieties = [{id:null, name: 'TODAS LAS SOCIEDADES'}, ...this.sociedades ]
    if(this.editar === true)
    {
      let datosImg = {
        code: this.item.code,
        id: this.item.id
      }
      await this.getImageByPromo(datosImg)
      this.codigo = this.item.code
      this.sociedadSelectedId = this.item.idSociedad
      this.nombre =this.item.name
      this.codSociedad != null ? this.socSelected.code : null
      this.descSociedad != null ? this.socSelected.name : null
      this.direccion = this.item.address
      this.codigoPostal = this.item.poltalCode
      this.poblacion = this.item.city
      this.provincia = this.item.region
      this.pais = this.item.country
      this.sector = this.item.sector
      if(this.imagenesPromo.length != 0)
      {
        let values = {
        documentoGrande: this.imagenesPromo[0].documentoMiniatura,
        nombre: this.imagenesPromo[0].nombre,
        mime: this.imagenesPromo[0].mime,
        id: this.imagenesPromo[0].id,
        tamanio: 10
      }
      this.files.push(values)
    }
    }
  },
  computed: {
    promocion(){
      const value = {
      code: this.codigo,
      name: this.nombre,
      idSociedad: this.sociedadSelectedId,
      codSociedad: this.sociedadSelectedId != null ? this.socSelected.code : null,
      descSociedad: this.sociedadSelectedId != null ? this.socSelected.name : null,
      direccion: this.direccion != null ? this.direccion : '',
      codigoPostal: this.codigoPostal != null ? this.codigoPostal : '',
      poblacion: this.poblacion != null ? this.poblacion : '',
      provincia: this.provincia != null ? this.provincia : '',
      pais: this.pais != null ? this.pais : '',
      sector: this.sector,
      files: this.files,
      fotoCambiada: this.fotoCambiada,
      fileId: this.editar === true && this.fotoCambiada === true && this.imagenesPromo.length != 0 ? this.imagenesPromo[0].id : null
      }
      return value
    },
    sociedades(){
      if (this.$store.state.gestion.societies) {

        return this.$store.state.gestion.societies
      }
      return []
    },
    imagenesPromo(){
      if (this.$store.state.gestion.imageByPromo) {

        return this.$store.state.gestion.imageByPromo
      }
      return []
    },
    localization () {
      return this.$t('popUpCrearPromociones')
    },
  },
  async mounted () {
    await this.obtenerSociedades()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      obtenerSociedades: 'gestion/obtenerSociedades',
      getImageByPromo: 'gestion/getImageByPromo'
    }),
    cambiarFoto(){
      if(this.editar === true)
      {
        this.fotoCambiada = true
      }
    },
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true

    },
    enviarPromocion(){
      this.$refs.formPromociones.validate()
      if (!this.valid) {
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
      } else {

      this.$emit('aceptar', this.promocion)
      this.cerrarPopup()
      }
    },
  },
  watch: {
    sociedadSelectedId() {
      this.socSelected = this.sociedades.find(x=> x.id === this.sociedadSelectedId)

    },
  }
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>
